import { CanActivateFn, Router, UrlTree } from "@angular/router";
import { combineLatest, Observable } from "rxjs";
import { config } from "@config";
import { Helper } from "@helpers/functions";
import { ADVANCED_TRADING_LOGIN, ADVANCED_TRADING_MODAL_SEEN } from "@helpers/constants";
import { inject } from "@angular/core";
import { LaunchDarklyService, LD_FLAG } from "@core-services/launch-darkly/launch-darkly.service";
import { map, switchMap } from "rxjs/operators";
import { AdvTradingRemote } from "../infrastructure/adv-trading.remote";
import { TermsAndConditionsService } from "@modules/shared/terms-and-conditions/services/terms-and-conditions.service";
import { FEAT_GATES, StatsigClientService } from "@core-services/statsig/statsig.service";

export const advancedTradingGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
	const launchDarklyService = inject(LaunchDarklyService);
	const statsigService = inject(StatsigClientService);
	const remote = inject(AdvTradingRemote);
	const tCService = inject(TermsAndConditionsService);
	const router = inject(Router);

	const bundles$ = remote
		.checkIfUserIsProvisioned$()
		.pipe(switchMap((provision) => tCService.getBundlesRemote(provision.user_journey)));

	return combineLatest({
		isFusionEnabled: launchDarklyService.isActive$(LD_FLAG.ADVANCED_TRADING),
		fusionExperienceEnabled: statsigService.isFeatureActive(FEAT_GATES.FUSION_EXPERIENCE_ENABLED),
		bundles: bundles$
	}).pipe(
		map(({ isFusionEnabled, fusionExperienceEnabled, bundles }) => {
			if (isFusionEnabled) {
				if (
					((Helper.getCookie(ADVANCED_TRADING_LOGIN) !== "null" &&
						Helper.getCookie(ADVANCED_TRADING_LOGIN) !== null) ||
						Helper.getCookie(ADVANCED_TRADING_MODAL_SEEN) === "true") &&
					bundles.length === 0
				) {
					window.location.href = fusionExperienceEnabled
						? config.V4AppBaseUrl + "/fusion"
						: config.advancedTrading.interfaceUrl;
					Helper.removeCookie(ADVANCED_TRADING_LOGIN);
					return false;
				}

				Helper.removeCookie(ADVANCED_TRADING_LOGIN);
				return true;
			}

			return router.createUrlTree(["/home"]);
		})
	);
};
